import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateCalculatorService {

  /**
   * Calcula a data de término do contrato baseada na regra de negócio:
   * Data Início + Prazo (meses) + 6 meses.
   * 
   * Regra de Negócio (Renova+):
   * O período vigente é considerado: data início do contrato + prazo (em meses) + 6 meses.
   * Se a data atual estiver dentro deste período, o cliente é elegível para renovação.
   * 
   * @param dataInicio Data de início do contrato (string no formato YYYY-MM-DD ou DD/MM/YYYY)
   * @param prazo Prazo do contrato em meses
   * @returns Data formatada (DD/MM/YYYY) ou '-' em caso de erro/dados inválidos
   */
  calcularDataFimContrato(dataInicio: string, prazo: number): string {
    if (!dataInicio || prazo === undefined || prazo === null) return '-';

    let date: Date;

    // Tenta parsear a data (suporta ISO YYYY-MM-DD ou BR DD/MM/YYYY)
    if (dataInicio.includes('-')) {
      // Formato ISO (YYYY-MM-DD)
      const parts = dataInicio.split('T')[0].split('-');
      date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    } else if (dataInicio.includes('/')) {
      // Formato BR (DD/MM/YYYY)
      const parts = dataInicio.split('/');
      date = new Date(+parts[2], +parts[1] - 1, +parts[0]);
    } else {
      return '-';
    }

    if (isNaN(date.getTime())) return '-';

    // Regra: Data Início + Prazo + 6 meses
    // Adiciona o prazo em meses e mais 6 meses adicionais conforme regra de negócio
    date.setMonth(date.getMonth() + prazo + 6);

    return date.toLocaleDateString('pt-BR');
  }

  /**
   * Calcula a data de término para exibição: data início + prazo (meses).
   * Não adiciona os 6 meses extras usados apenas para a regra de elegibilidade.
   */
  calcularDataFimContratoSemBonus(dataInicio: string, prazo: number): string {
    if (!dataInicio || prazo === undefined || prazo === null) return '-';

    let date: Date;
    if (dataInicio.includes('-')) {
      const parts = dataInicio.split('T')[0].split('-');
      date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
    } else if (dataInicio.includes('/')) {
      const parts = dataInicio.split('/');
      date = new Date(+parts[2], +parts[1] - 1, +parts[0]);
    } else {
      return '-';
    }

    if (isNaN(date.getTime())) return '-';

    date.setMonth(date.getMonth() + prazo);
    return date.toLocaleDateString('pt-BR');
  }
}
